<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-arrow-down-bold"
      title="About our Products"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'A New Kind of Loan',
          subtitle: 'Unbeatable Savings',
          text: 'With the HEQLOAN or HEQLOC from HEQ you can take advantage of the equity in your property, skip payments, and get a low 2% fixed rate.',
          callout: '01',
        },
        {
          title: 'HEQ Tokens',
          subtitle: 'Real Assets Real Stability',
          text: 'Meet the stablecoins with real value backed by real estate with real liquidity.  Now your crypto assets can have real value.',
          callout: '02',
        },
        {
          title: 'Real Estate',
          subtitle: 'Real Liquidity',
          text: 'Turn your equity into a real asset.  With HEQ Loans your real estate equity becomes liquid again.',
          callout: '03',
        },
      ],
    }),
  }
</script>
